const TOU_CONSENTS = {
  conversationalAssistant: 'Conversational Assistant',
  healthhub: 'HealthHub+',
  healthPlanAI: 'Health Plan AI',
} as const;

export { TOU_CONSENTS };
